import PolyBasic from "./PolyBasic.json"
import TransferableERC721 from "./TransferableERC721.json"
import AccesslistERC721 from "./AccesslistERC721.json"
import WETH from "./WETH.json"

import {ethers} from 'ethers'

const contracts = {

    "PolyBasic": PolyBasic,
    "WETH": WETH,
    "TransferableERC721": TransferableERC721,
    "AccesslistERC721": AccesslistERC721
}

const load = (provider, settings) => {
    const json = contracts[settings.contractType]

    console.log("get contract", settings, json)
    if (!json){
        console.error("Contract Not Found:", settings.contractType)
        return null
    }
    return new ethers.Contract(settings.contract, json.abi, provider);
}

export default {
    load
}